export default "__VITE_ASSET__BD9fPnCA__"